import axios from 'axios';
import {backendHost} from '../../config';

export const getMedia = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/media`, {params});
};